import { FeatureToggle, TwoColumnBlock } from '../../models/app-data-model';
import ColumnContentBlock from '../column-content-block/ColumnContentBlock';
import React from 'react';
import './TwoColumnContentBlock.scss'
import { Grid2 } from '@mui/material';

export type TwoColumnContentBlockProps = {
  content: TwoColumnBlock;
  featureToggles: FeatureToggle[];
};

const TwoColumnContentBlock: React.FC<TwoColumnContentBlockProps> = ({ content, featureToggles }: TwoColumnContentBlockProps) => {
  let firstColumnHasImage = false;
  let secondColumnHasImage = false;

  const firstColumn = content.first_column && content.first_column.map((item, index) => {
    // TODO: QA this properly
    if (item.media && item.media?.contenthub_asset && (item.media?.contenthub_asset.length > 0 || item.media?.manual_overwrites.url.length > 0)) {
      firstColumnHasImage = true;
    }

    return <ColumnContentBlock columnItem={item} key={index} featureToggles={featureToggles} />
  });

  const secondColumn = content.second_column && content.second_column.map((item, index) => {
    if (item.media && item.media?.contenthub_asset && (item.media?.contenthub_asset.length > 0 || item.media?.manual_overwrites.url.length > 0)) {
      secondColumnHasImage = true;
    }

    return <ColumnContentBlock columnItem={item} key={index} featureToggles={featureToggles} />
  });
  const container_style = content.container_style;

  return (
    <Grid2 size={{ xs: 12 }} container rowSpacing={2} columnSpacing={3} className={'two-column-content-block ' + container_style}>
      <Grid2 size={{ xs: 12, md: 6 }} className={`first-column${!firstColumnHasImage ? ' content-block' : ''}`}>
        {firstColumn}
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }} className={`second-column${!secondColumnHasImage ? ' content-block' : ''}`}>
        {secondColumn}
      </Grid2>
    </Grid2>
  );
};

export default TwoColumnContentBlock;
